import { render, staticRenderFns } from "./ruleForm.vue?vue&type=template&id=720571a6&scoped=true"
import script from "./ruleForm.vue?vue&type=script&lang=js"
export * from "./ruleForm.vue?vue&type=script&lang=js"
import style0 from "./ruleForm.vue?vue&type=style&index=0&id=720571a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720571a6",
  null
  
)

export default component.exports